import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import CustomhtmlForFeature from 'utils/CustomDefault';
import { colorCategories } from '@deck.gl/carto';

export const BROWARDPREMOPROJECT_LAYER_ID = 'browardPremoProjectLayer';

export const CATEGORY_COLORS = {
  'Bus Rapid Transit': [25, 57, 138],
  'Light Rail Transit': [241, 100, 119],
  'Broward Commuter Rail South': [231, 166, 20],
  'High Frequency Corridors': [0, 158, 88],
  'Future Light Rail West Extension Options': [255, 153, 167],
};

const layerConfig = {
  title: 'PREMO Projects',
};

function BrowardPremoProjectLayer() {
  const dispatch = useDispatch();
  const { browardPremoProjectLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, browardPremoProjectLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (browardPremoProjectLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: BROWARDPREMOPROJECT_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: browardPremoProjectLayer.visible,
      opacity: browardPremoProjectLayer.opacity,
      getLineColor: colorCategories({
        attr: 'Project_Type',
        domain: Object.keys(CATEGORY_COLORS),
        colors: Object.values(CATEGORY_COLORS),
      }),
      lineWidthMinPixels: 2,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: BROWARDPREMOPROJECT_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: CustomhtmlForFeature({
              feature: info.object,
              title: 'PREMO Project Details',
              includeColumns: [
                'Project_Type',
                'Project_Status',
                'Capital_Investment',
                'Projected_Start_Year',
                'Projected_End_Year',
              ],
            }),
          };
        }
      },
    });
  }
}

export default BrowardPremoProjectLayer;
